import { render } from 'preact';
import { App } from './App.tsx';
import { captureAttribution } from './attribution.ts';
import { captureLiFatId } from './li-fat-id.ts';
import { initExperiments } from './experiments.ts';
import { installInteractionObservers } from './instrumentation.ts';
import { initSentry } from './sentry.ts';
import { router } from './router.tsx';
import './styles/tokens.css';
import './styles/primitives.css';
import './app.css';

initSentry(router);
// Must run after initSentry so the scope exists; re-stamps first-touch ad
// attribution onto every pageload so a later pageview carries the source.
captureAttribution();
// Persist LinkedIn's li_fat_id into a cookie shared across the www.→app. origin
// hop, so the waitlist/signup on app. can attribute the click. Independent of
// Sentry; safe to call on every landing.
captureLiFatId();
// Assign this visitor a homepage-experiment variant and stamp it onto the Sentry
// scope before render, so every span/event/replay carries it and Home.tsx renders
// the right variant with no flash. No-ops when nothing is enrolling. See
// docs/experimentation.md.
initExperiments();
// One observer pass drives both the data-gp-observe-* Sentry spans and the
// data-gp-conversion-* LinkedIn ad beacons (the Sign Up CTA click, the homepage
// ad-landing view). See docs/martech.md.
installInteractionObservers();

render(<App />, document.getElementById('app')!);
